module.exports = __webpack_public_path__ + "img/System-logo.f048e4d6.svg";